interface ConditionFilterPillsProps {
  conditions: { slug: string; label: string; topicCount: number }[];
  selected: string | null;
  onSelect: (slug: string | null) => void;
}

export default function ConditionFilterPills({ conditions, selected, onSelect }: ConditionFilterPillsProps) {
  return (
    <div className="flex gap-1.5 overflow-x-auto pb-1 -mx-4 px-4 scrollbar-hide">
      <button
        onClick={() => onSelect(null)}
        className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors ${
          selected === null
            ? 'bg-pink-500 text-white'
            : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'
        }`}
      >
        All Topics
      </button>
      {conditions.map(c => (
        <button
          key={c.slug}
          onClick={() => onSelect(c.slug === selected ? null : c.slug)}
          className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors ${
            selected === c.slug
              ? 'bg-pink-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'
          }`}
        >
          {c.label} ({c.topicCount})
        </button>
      ))}
    </div>
  );
}
